/* eslint-disable react/prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import OptionGroup from "./OptionGroup";
import menuRenderer from "./menuRenderer";
import MultiDropdownSelect from "../core/input/MultiDropdownSelect";
var RequirementCategorySelectorInput = function RequirementCategorySelectorInput(_ref) {
  var className = _ref.className,
    id = _ref.id,
    fieldName = _ref.fieldName,
    options = _ref.options,
    placeholder = _ref.placeholder;
  return /*#__PURE__*/React.createElement("div", {
    className: className,
    id: id
  }, fieldName ? /*#__PURE__*/React.createElement(Field, {
    name: fieldName,
    component: MultiDropdownSelect,
    type: "select",
    multi: false,
    clearable: true,
    options: options,
    placeholder: placeholder,
    menuRenderer: menuRenderer,
    optionGroupComponent: OptionGroup
  }) : /*#__PURE__*/React.createElement(MultiDropdownSelect, {
    clearable: true,
    multi: false,
    options: options
  }));
};
RequirementCategorySelectorInput.propTypes = {
  className: PropTypes.string,
  id: PropTypes.string,
  placeholder: PropTypes.string
};
export default RequirementCategorySelectorInput;